<template>
    <div>
        <a class="floating-call"
           href="tel:6629854708"
           :aria-label="`${t.common.callUs}: 662-985-4708`">
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.7 19.7 0 0 1-8.6-3.1 19.4 19.4 0 0 1-6-6A19.7 19.7 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.8a2 2 0 0 1-.4 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2Z" />
            </svg>

            <span>{{ t.common.callUs }}</span>
        </a>

        <footer class="site-footer">
            <div class="container">
                <div class="footer-heading">
                    <a class="footer-brand"
                       href="#home"
                       aria-label="MMP Concrete LLC home">
                        <img src="@/assets/logo.png" alt="MMP Concrete LLC" />

                        <div>
                            <strong>MMP</strong>
                            <span>CONCRETE LLC</span>
                        </div>
                    </a>

                    <p>{{ t.footer.slogan }}</p>

                    <div class="social-links">
                        <!-- Facebook -->
                        <a href="https://www.facebook.com/profile.php?id=61571388341190"
                           target="_blank"
                           rel="noopener noreferrer"
                           aria-label="Facebook">
                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M14 8h3V4h-3c-3 0-5 2-5 5v3H6v4h3v6h4v-6h3l1-4h-4V9c0-.7.3-1 1-1Z" />
                            </svg>
                        </a>

                        <!-- Instagram -->
                        <a href="https://www.instagram.com/MMP_concrete"
                           target="_blank"
                           rel="noopener noreferrer"
                           aria-label="Instagram">
                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                <rect x="3" y="3" width="18" height="18" rx="5" />
                                <circle cx="12" cy="12" r="4" />
                                <circle class="instagram-dot" cx="17.5" cy="6.5" r="1" />
                            </svg>
                        </a>

                        <!-- TikTok -->
                        <a href="https://www.tiktok.com/@mmp.concrete"
                           target="_blank"
                           rel="noopener noreferrer"
                           aria-label="TikTok">
                            <svg viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M15 3v11.5a4.5 4.5 0 1 1-4-4.5" />
                                <path d="M15 3c.7 3 2.5 4.6 5 5" />
                            </svg>
                        </a>
                    </div>
                </div>

                <div class="footer-content">
                    <div class="footer-column">
                        <strong>{{ t.footer.explore }}</strong>

                        <a href="#about">{{ t.navigation.about }}</a>
                        <a href="#services">{{ t.navigation.services }}</a>
                        <a href="#projects">{{ t.navigation.projects }}</a>
                        <a href="#process">{{ t.navigation.process }}</a>
                    </div>

                    <div class="footer-column">
                        <strong>{{ t.footer.serviceArea }}</strong>

                        <span>North Mississippi</span>
                        <span>{{ t.footer.surroundingAreas }}</span>
                        <a href="#service-area">
                            {{ t.footer.checkAvailability }}
                        </a>
                    </div>

                    <div class="footer-column">
                        <strong>{{ t.footer.startProject }}</strong>

                        <a href="#contact">
                            {{ t.footer.requestEstimate }}
                        </a>

                        <a href="tel:6629854708">
                            662-985-4708
                        </a>

                        <a href="mailto:MMPConcrete@gmail.com">
                            MMPConcrete@gmail.com
                        </a>
                    </div>
                </div>

                <div class="footer-bottom">
                    <span>
                        © {{ currentYear }} MMP Concrete LLC.
                        {{ t.footer.rights }}
                    </span>

                    <span>{{ t.footer.closing }}</span>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
  name: 'SiteFooter',

  props: {
    t: {
      type: Object,
      required: true
    }
  },

  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
    .site-footer {
        padding: 70px 0 28px;
        color: var(--color-white);
        background-color: #11110f;
    }

    .footer-heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 35px;
        padding-bottom: 45px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    }

    .footer-brand {
        display: flex;
        align-items: center;
        gap: 13px;
    }

        .footer-brand img {
            width: 58px;
            height: 58px;
            object-fit: contain;
            border-radius: 4px;
        }

        .footer-brand strong {
            display: block;
            font-size: 22px;
            font-weight: 900;
            letter-spacing: 0.08em;
            line-height: 1;
        }

        .footer-brand span {
            display: block;
            margin-top: 7px;
            font-size: 8px;
            font-weight: 700;
            letter-spacing: 0.32em;
        }

    .footer-heading > p {
        margin: 0;
        color: #b7b3aa;
        font-family: var(--font-heading);
        font-size: 23px;
        font-style: italic;
    }

    .social-links {
        display: flex;
        gap: 10px;
    }

        .social-links a {
            display: grid;
            width: 44px;
            height: 44px;
            place-items: center;
            color: var(--color-white);
            border: 1px solid rgba(255, 255, 255, 0.3);
            border-radius: 50%;
            transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
        }

            .social-links a:hover {
                background-color: var(--color-orange);
                border-color: var(--color-orange);
                transform: translateY(-3px);
            }

        .social-links svg {
            width: 20px;
            height: 20px;
            fill: none;
            stroke: currentColor;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 1.6;
        }

        .social-links a:first-child svg {
            fill: currentColor;
            stroke: none;
        }

    .instagram-dot {
        fill: currentColor;
        stroke: none;
    }

    .footer-content {
        display: grid;
        padding-block: 55px;
        grid-template-columns: repeat(3, 1fr);
        gap: 45px;
    }

    .footer-column {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        gap: 12px;
    }

        .footer-column > strong {
            margin-bottom: 10px;
            color: var(--color-white);
            font-size: 9px;
            letter-spacing: 0.18em;
            text-transform: uppercase;
        }

        .footer-column a,
        .footer-column span {
            color: #9e9a91;
            font-size: 13px;
            line-height: 1.5;
            transition: color 0.2s ease;
        }

            .footer-column a:hover {
                color: var(--color-orange);
            }

    .footer-bottom {
        display: flex;
        padding-top: 28px;
        justify-content: space-between;
        gap: 25px;
        color: #77736c;
        border-top: 1px solid rgba(255, 255, 255, 0.12);
        font-size: 9px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
    }

    .floating-call {
        position: fixed;
        z-index: 900;
        right: 24px;
        bottom: 24px;
        display: flex;
        min-height: 52px;
        align-items: center;
        justify-content: center;
        gap: 10px;
        padding: 0 20px;
        color: var(--color-white);
        background-color: var(--color-orange);
        border-radius: 30px;
        box-shadow: 0 10px 28px rgba(0, 0, 0, 0.3);
        font-size: 10px;
        font-weight: 800;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        transition: background-color 0.25s ease, transform 0.25s ease;
    }

        .floating-call:hover {
            background-color: var(--color-orange-dark);
            transform: translateY(-3px);
        }

        .floating-call svg {
            width: 19px;
            fill: none;
            stroke: currentColor;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 1.7;
        }

    @media (max-width: 760px) {
        .footer-heading {
            align-items: flex-start;
            flex-wrap: wrap;
        }

            .footer-heading > p {
                width: 100%;
            }

        .footer-content {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (max-width: 520px) {
        .footer-content {
            grid-template-columns: 1fr;
        }

        .footer-bottom {
            flex-direction: column;
        }

        .floating-call {
            right: 15px;
            bottom: 15px;
            width: 52px;
            padding: 0;
        }

            .floating-call span {
                display: none;
            }
    }
</style>